import React from "react";
import clsx from "clsx";

import "./index.scss";

import PcInputTitle from "components/molecules/PcInputTitle";

const PcAccordionRadio = ({
  title,
  label,
  list,
  visible,
}) => {
  return (
    <div className="PcAccordionRadio">
      <div className="pc-accordion-radio-area-wrapper">
        <div className={clsx('pc-cmnt-area', { visible })}>
          <div className="arrowArea"></div>
          <div className="pcCollpseAreaBackground">
            <PcInputTitle
              title={title}
              label={label}
              list={list}
              type="RadioInput"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PcAccordionRadio;
